import api from './api'
import { CatalogGetParams, CatalogUpdatePayload } from '../types/catalog'
 
export const catalogApi = {
  getContent: async (params: CatalogGetParams) => {
    const response = await api.get('/content', { params })
    return response.data
  },
 
  getContentById: async (id: string, smbId: string) => {
    const response = await api.get(`/content/${id}`, {
      params: { smb_id: smbId },
    })
    return response.data
  },
 
  createContent: async (smbId: string, payload: FormData) => {
    const response = await api.post(`/content?smb_id=${smbId}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },
 
  updateContent: async (
    id: string,
    smbId: string,
    updates: CatalogUpdatePayload | FormData
  ) => {
    const isFormData = updates instanceof FormData;
    const response = await api.patch(`/content/${id}`, updates, {
      params: { smb_id: smbId },
      ...(isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}),
    })
    return response.data
  },
 
  deleteContent: async (id: string, smbId: string) => {
    const response = await api.delete(`/content/${id}`, {
      params: { smb_id: smbId },
    })
    return response.data
  },

  toggleContentStatus: async (id: string, smbId: string, status: 'active' | 'inactive') => {
    const formData = new FormData();
    formData.append('status', status);
    const response = await api.patch(`/content/${id}`, formData, {
      params: { smb_id: smbId },
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  updateSMBProduct: async (
    id: string,
    smbId: string,
    updates: CatalogUpdatePayload
  ) => {
    const response = await api.patch(`/content/smb_products/${id}`, updates, {
      params: { smb_id: smbId },
    })
    return response.data
  },
 
  deleteSMBProduct: async (id: string, smbId: string) => {
    const response = await api.delete(`/content/smb_products/${id}`, {
      params: { smb_id: smbId },
    })
    return response.data
  },
}
 
export default catalogApi
